<div class="flex flex-col gap-6" style="padding: 25px">
  <div class="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
    <div class="flex flex-col gap-1">
      <span class="text-black font-black uppercase">Motor de recomendação por kits</span>
      <small class="text-xs text-chathams-blue">
        Para marcas de catálogo pequeno, que vendem kits fechados em vez de produtos avulsos.
      </small>
    </div>

    <a
      routerLink="/dash/catalogo-produtos"
      class="h-9 px-4 btn btn--secondary inline-flex items-center justify-center whitespace-nowrap"
    >
      Abrir catálogo de produtos
    </a>
  </div>

  <!-- Empresa -->
  <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <span class="text-sm font-bold uppercase text-chathams-blue">Empresa</span>
      <small class="text-xs text-chathams-blue">
        A configuração vale para a empresa inteira, em todos os totens dela.
      </small>
    </div>

    <ng-select
      [items]="companies"
      bindLabel="name"
      bindValue="id"
      placeholder="Selecione a empresa"
      [formControl]="companyControl"
      (change)="onCompanySelectionChanged($any($event)?.id ?? null)"
    ></ng-select>
  </div>

  <ng-container *ngIf="selectedCompanyId">
    <div *ngIf="isLoading" class="text-sm text-chathams-blue">Carregando configuração...</div>

    <!-- Empresa no motor padrão -->
    <div *ngIf="!isLoading && !usesKitEngine" class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
      <div class="flex flex-col gap-1">
        <span class="text-sm font-bold uppercase text-chathams-blue">Esta empresa usa o motor padrão</span>
        <small class="text-xs text-chathams-blue">
          A recomendação escolhe produtos por pontuação, a partir da análise e do questionário. Troque para kits quando
          o catálogo for pequeno e a marca vender combinações fechadas.
        </small>
      </div>

      <div>
        <button
          *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']"
          type="button"
          class="h-9 px-4 btn btn--primary"
          (click)="enableKitEngine()"
        >
          Configurar motor por kits
        </button>
      </div>
    </div>

    <ng-container *ngIf="!isLoading && usesKitEngine && kitMatrix">
      <!-- Problemas de validação -->
      <div
        *ngIf="validationProblems.length"
        class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-3 border-l-4 border-cerise-red"
      >
        <span class="text-sm font-bold uppercase text-cerise-red">
          Corrija antes de salvar ({{ validationProblems.length }})
        </span>
        <ul class="flex flex-col gap-2">
          <li *ngFor="let problem of validationProblems" class="text-sm text-chathams-blue">• {{ problem }}</li>
        </ul>
      </div>

      <!-- Kits -->
      <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
        <div class="flex items-start justify-between gap-3">
          <div class="flex flex-col gap-1">
            <span class="text-sm font-bold uppercase text-chathams-blue">Kits</span>
            <small class="text-xs text-chathams-blue">
              Os produtos ficam na ordem de aplicação — é a ordem que a pessoa vê no totem.
            </small>
          </div>

          <button type="button" class="h-9 px-4 btn btn--secondary whitespace-nowrap" (click)="addKit()">
            Adicionar kit
          </button>
        </div>

        <div *ngIf="!kitMatrix.kits.length" class="text-sm text-gray-500">Nenhum kit cadastrado.</div>

        <div
          *ngFor="let kit of kitMatrix.kits; let kitIndex = index; trackBy: trackByIndex"
          class="border border-gray-200 rounded-xl p-4 flex flex-col gap-3"
        >
          <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
            <div class="flex flex-col gap-1">
              <label class="text-xs font-bold text-chathams-blue">Identificador</label>
              <input
                class="form-input"
                [value]="kit.id"
                (change)="onKitIdRenamed(kitIndex, $any($event.target).value)"
              />
            </div>

            <div class="flex flex-col gap-1">
              <label class="text-xs font-bold text-chathams-blue">Nome comercial</label>
              <input class="form-input" [(ngModel)]="kit.name" [ngModelOptions]="{ standalone: true }" />
            </div>

            <div class="flex flex-col gap-1">
              <label class="text-xs font-bold text-chathams-blue">Preço (opcional)</label>
              <input
                class="form-input"
                type="number"
                step="0.01"
                placeholder="sem preço"
                [(ngModel)]="kit.price"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>

            <div class="flex flex-col gap-1">
              <label class="text-xs font-bold text-chathams-blue">Link</label>
              <input class="form-input" [(ngModel)]="kit.linkUrl" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>

          <div *ngFor="let list of kitProductLists" class="flex flex-col gap-2">
            <label class="text-xs font-bold text-chathams-blue">{{ list.label }}</label>

            <div
              *ngFor="let productId of kit[list.key] ?? []; let productIndex = index"
              class="flex items-center gap-2"
            >
              <span
                class="text-xs font-bold text-white bg-chathams-blue rounded-full w-6 h-6 flex items-center justify-center"
              >
                {{ productIndex + 1 }}
              </span>
              <span class="text-sm text-chathams-blue flex-1">{{ productName(productId) }}</span>

              <button
                type="button"
                class="btn btn--ghost h-8 px-2"
                (click)="moveProductUp(kit, productIndex, list.key)"
              >
                ↑
              </button>
              <button
                type="button"
                class="btn btn--ghost h-8 px-2"
                (click)="moveProductDown(kit, productIndex, list.key)"
              >
                ↓
              </button>
              <button
                type="button"
                class="btn btn--ghost h-8 px-2 text-cerise-red"
                (click)="removeProductFromKit(kit, productIndex, list.key)"
              >
                remover
              </button>
            </div>

            <select
              class="form-input"
              #productSelect
              (change)="addProductToKit(kit, productSelect.value, list.key); productSelect.value = ''"
            >
              <option value="">Adicionar produto do catálogo...</option>
              <option *ngFor="let product of catalogProducts" [value]="product.id">
                {{ productName(product.id) }}
              </option>
            </select>
          </div>

          <div>
            <button type="button" class="btn btn--ghost h-8 px-2 text-cerise-red" (click)="removeKit(kitIndex)">
              Remover kit
            </button>
          </div>
        </div>
      </div>

      <!-- Matriz -->
      <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <span class="text-sm font-bold uppercase text-chathams-blue">Tabela de decisão</span>
          <small class="text-xs text-chathams-blue">
            As linhas são o que mais incomoda a pessoa; as colunas, o tamanho da rotina que ela já tem.
          </small>
        </div>

        <div class="flex flex-wrap items-end gap-2">
          <div *ngFor="let routine of kitMatrix.routines; let columnIndex = index" class="flex items-center gap-1">
            <input
              class="form-input w-40"
              [value]="routine"
              (change)="onRoutineRenamed(columnIndex, $any($event.target).value)"
            />
            <button type="button" class="btn btn--ghost h-8 px-2 text-cerise-red" (click)="removeRoutine(columnIndex)">
              ×
            </button>
          </div>

          <button type="button" class="h-9 px-4 btn btn--secondary" (click)="addRoutine()">Adicionar coluna</button>
        </div>

        <div class="overflow-x-auto">
          <table class="w-full text-sm">
            <thead>
              <tr>
                <th class="text-left p-2 text-chathams-blue">Necessidade</th>
                <th *ngFor="let routine of kitMatrix.routines" class="text-left p-2 text-chathams-blue">
                  {{ routine || '(sem nome)' }}
                </th>
                <th class="p-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let need of needs" class="border-t border-gray-200">
                <td class="p-2">
                  <div class="flex flex-col gap-1">
                    <span class="font-bold text-chathams-blue">{{ need }}</span>
                    <label class="text-xs text-gray-500 flex items-center gap-1">
                      <input type="checkbox" [checked]="isFixedNeed(need)" (change)="toggleFixedNeed(need)" />
                      nunca muda de coluna
                    </label>
                  </div>
                </td>

                <td *ngFor="let routine of kitMatrix.routines; let columnIndex = index" class="p-2">
                  <select
                    class="form-input"
                    [ngModel]="kitMatrix.matrix[need][columnIndex]"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="setCell(need, columnIndex, $event)"
                  >
                    <option value="">—</option>
                    <option *ngFor="let kit of kitMatrix.kits" [value]="kit.id">{{ kit.name || kit.id }}</option>
                  </select>
                </td>

                <td class="p-2">
                  <button type="button" class="btn btn--ghost h-8 px-2 text-cerise-red" (click)="removeNeed(need)">
                    remover
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="flex items-center gap-2">
          <input class="form-input w-64" placeholder="Nova necessidade (linha)" #needInput />
          <button
            type="button"
            class="h-9 px-4 btn btn--secondary"
            (click)="addNeed(needInput.value); needInput.value = ''"
          >
            Adicionar linha
          </button>
        </div>
      </div>

      <!-- Perguntas -->
      <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <span class="text-sm font-bold uppercase text-chathams-blue">Respostas do questionário</span>
          <small class="text-xs text-chathams-blue">
            Liga cada resposta a uma linha, a uma coluna ou a uma faixa de idade.
          </small>
        </div>

        <div *ngIf="!questionOptions.length" class="text-sm text-gray-500">
          Nenhuma pergunta ativa encontrada para esta empresa.
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <!-- Necessidade -->
          <div class="flex flex-col gap-2">
            <span class="text-xs font-bold uppercase text-chathams-blue">Necessidade (linha)</span>

            <div
              *ngFor="let entry of optionMapEntries('need'); trackBy: trackByOptionId"
              class="flex items-center gap-2 text-sm"
            >
              <span class="flex-1 text-chathams-blue">{{ optionLabel(entry.optionId) }}</span>
              <span class="font-bold text-chathams-blue">{{ entry.value }}</span>
              <button
                type="button"
                class="btn btn--ghost h-8 px-2 text-cerise-red"
                (click)="removeOptionMapping('need', entry.optionId)"
              >
                ×
              </button>
            </div>

            <div class="flex flex-col gap-1">
              <select class="form-input" #needOption>
                <option value="">Resposta...</option>
                <option *ngFor="let option of questionOptions" [value]="option.optionId">{{ option.label }}</option>
              </select>

              <select class="form-input" #needValue>
                <option value="">Linha...</option>
                <option *ngFor="let need of needs" [value]="need">{{ need }}</option>
              </select>

              <button
                type="button"
                class="h-9 px-4 btn btn--secondary"
                (click)="addOptionMapping('need', needOption.value, needValue.value); needOption.value = ''"
              >
                Ligar
              </button>
            </div>
          </div>

          <!-- Rotina -->
          <div class="flex flex-col gap-2">
            <span class="text-xs font-bold uppercase text-chathams-blue">Rotina (coluna)</span>

            <div
              *ngFor="let entry of optionMapEntries('routine'); trackBy: trackByOptionId"
              class="flex items-center gap-2 text-sm"
            >
              <span class="flex-1 text-chathams-blue">{{ optionLabel(entry.optionId) }}</span>
              <span class="font-bold text-chathams-blue">{{ entry.value }}</span>
              <button
                type="button"
                class="btn btn--ghost h-8 px-2 text-cerise-red"
                (click)="removeOptionMapping('routine', entry.optionId)"
              >
                ×
              </button>
            </div>

            <div class="flex flex-col gap-1">
              <select class="form-input" #routineOption>
                <option value="">Resposta...</option>
                <option *ngFor="let option of questionOptions" [value]="option.optionId">{{ option.label }}</option>
              </select>

              <select class="form-input" #routineValue>
                <option value="">Coluna...</option>
                <option *ngFor="let routine of kitMatrix.routines" [value]="routine">{{ routine }}</option>
              </select>

              <button
                type="button"
                class="h-9 px-4 btn btn--secondary"
                (click)="addOptionMapping('routine', routineOption.value, routineValue.value); routineOption.value = ''"
              >
                Ligar
              </button>
            </div>
          </div>

          <!-- Idade -->
          <div class="flex flex-col gap-2">
            <span class="text-xs font-bold uppercase text-chathams-blue">Faixa de idade</span>

            <div
              *ngFor="let entry of optionMapEntries('age'); trackBy: trackByOptionId"
              class="flex items-center gap-2 text-sm"
            >
              <span class="flex-1 text-chathams-blue">{{ optionLabel(entry.optionId) }}</span>
              <span class="font-bold text-chathams-blue">{{ entry.value }}</span>
              <button
                type="button"
                class="btn btn--ghost h-8 px-2 text-cerise-red"
                (click)="removeOptionMapping('age', entry.optionId)"
              >
                ×
              </button>
            </div>

            <div class="flex flex-col gap-1">
              <select class="form-input" #ageOption>
                <option value="">Resposta...</option>
                <option *ngFor="let option of questionOptions" [value]="option.optionId">{{ option.label }}</option>
              </select>

              <input class="form-input" placeholder="Ex.: 35a44" #ageValue />

              <button
                type="button"
                class="h-9 px-4 btn btn--secondary"
                (click)="
                  addOptionMapping('age', ageOption.value, ageValue.value); ageOption.value = ''; ageValue.value = ''
                "
              >
                Ligar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Regra de idade -->
      <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
        <div class="flex items-start justify-between gap-3">
          <div class="flex flex-col gap-1">
            <span class="text-sm font-bold uppercase text-chathams-blue">Exceção por faixa de idade</span>
            <small class="text-xs text-chathams-blue">
              Move a pessoa de uma coluna para outra. Linhas marcadas como fixas não são afetadas.
            </small>
          </div>

          <label class="text-sm text-chathams-blue flex items-center gap-2 whitespace-nowrap">
            <input type="checkbox" [checked]="hasAgeRule" (change)="toggleAgeRule()" />
            usar exceção
          </label>
        </div>

        <div *ngIf="kitMatrix.ageRule" class="flex flex-col gap-3">
          <div class="flex flex-wrap items-center gap-3">
            <label class="text-sm text-chathams-blue">
              da coluna
              <select
                class="form-input inline-block w-40 ml-1"
                [(ngModel)]="kitMatrix.ageRule.fromColumn"
                [ngModelOptions]="{ standalone: true }"
              >
                <option *ngFor="let routine of kitMatrix.routines; let i = index" [ngValue]="i">{{ routine }}</option>
              </select>
            </label>

            <label class="text-sm text-chathams-blue">
              para
              <select
                class="form-input inline-block w-40 ml-1"
                [(ngModel)]="kitMatrix.ageRule.toColumn"
                [ngModelOptions]="{ standalone: true }"
              >
                <option *ngFor="let routine of kitMatrix.routines; let i = index" [ngValue]="i">{{ routine }}</option>
              </select>
            </label>
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-xs font-bold text-chathams-blue">Faixas que acionam</span>
            <div *ngIf="!mappedAgeValues.length" class="text-xs text-gray-500">
              Ligue respostas a faixas de idade acima para escolher aqui.
            </div>
            <label *ngFor="let ageValue of mappedAgeValues" class="text-sm text-chathams-blue flex items-center gap-2">
              <input type="checkbox" [checked]="isAgeTrigger(ageValue)" (change)="toggleAgeTrigger(ageValue)" />
              {{ ageValue }}
            </label>
          </div>
        </div>
      </div>

      <!-- Sinais, necessidades e trocas -->
      <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <span class="text-sm font-bold uppercase text-chathams-blue">Sinais, necessidades e trocas (opcional)</span>
          <small class="text-xs text-chathams-blue">
            JSON com columnSignals, signals, needs e swaps. Deixe vazio para usar só o mapa de respostas acima.
          </small>
        </div>

        <textarea
          class="form-input font-mono text-xs"
          rows="12"
          spellcheck="false"
          [class.border-cerise-red]="routingJsonError"
          [value]="routingJson"
          (input)="onRoutingJsonChanged($any($event.target).value)"
        ></textarea>
        <span *ngIf="routingJsonError" class="text-xs text-cerise-red">{{ routingJsonError }}</span>
      </div>

      <!-- Ações -->
      <div class="flex flex-wrap items-center gap-3">
        <button
          *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']"
          type="button"
          class="h-11 px-6 btn btn--primary"
          [disabled]="isSaving || !!routingJsonError"
          (click)="save()"
        >
          {{ isSaving ? 'Salvando...' : 'Salvar configuração' }}
        </button>

        <button
          *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']"
          type="button"
          class="h-11 px-6 btn btn--ghost text-cerise-red"
          [disabled]="isRemoving"
          (click)="removeKitEngine()"
        >
          {{ isRemoving ? 'Removendo...' : 'Voltar ao motor padrão' }}
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
